export default __webpack_public_path__ + "static/media/04.59ae53bf.jpg";